import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import fr from 'vuetify/es5/locale/fr';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { fr },
        current: 'fr'
    },
    icons: {
        iconfont: 'mdi' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    },
    theme: {
        themes: {
            light: {
                primary: '#8C2F48',
                secondary: '#FCB3C6',
                button: '#F3DFA2'
            }
        }
    }
});